import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { DashboardLayout } from "component/layout/dashboard";
import { PageProps } from "shared/page-props";
import * as Router from "react-router-dom";
import * as Icons from "react-feather";
import { FeatherIcon } from "component/shared/feather-icon";
import { styles } from "./style";
import { AppCard } from "component/shared/app-card";
import * as env from "shared/env";
import * as paths from "routes/paths";

interface Props extends
	PageProps,
	Router.RouteComponentProps,
	WithStyles<typeof styles> {}

const Component: React.FC<Props> = ({ user, classes = {} }) => {
	const title = "Billing Info";

	// The refreshed Account page's Billing tab replaces this page; a non-admin, non-owner lands on General.
	if (env.billingRefresh) {
		return <Router.Redirect to={`${paths.settingsAccount}?tab=billing`} />;
	}

	return (
		<DashboardLayout
			permitted={user && user.permissions.billing}
			title={title}
			header={
				<Mui.Typography variant="h1">
					{title}
				</Mui.Typography>
			}
		>
			<AppCard className={classes.supportMessageCard}>
				<Mui.CardContent>
					<Mui.Typography variant="h5" className={classes.supportMessageTitle}>
						Contact Support to Update Billing Information
					</Mui.Typography>
					<Mui.Typography variant="body1" className={classes.supportMessageText}>
						To update your billing information, please contact our support team.
						Our team is ready to assist you with any credit card or billing updates.
					</Mui.Typography>
					<div className={classes.contactInfo}>
						<div className={classes.contactInfoItem}>
							<Icons.Mail size={20} className={classes.contactIcon} />
							<Mui.Typography variant="body2">
								<strong>Email:</strong> support@ihomefinder.com
							</Mui.Typography>
						</div>
						<div className={classes.contactInfoItem}>
							<Icons.Phone size={20} className={classes.contactIcon} />
							<Mui.Typography variant="body2">
								<strong>Phone:</strong> 866-700-8855
							</Mui.Typography>
						</div>
					</div>
					<Mui.Typography variant="body2" className={classes.clientIdNote}>
						For faster assistance, please include your Client ID: {user?.clientId}
					</Mui.Typography>
				</Mui.CardContent>
			</AppCard>
		</DashboardLayout>
	);
};

export const SettingsBillingPage = withStyles(Component, styles);